module.exports = __webpack_public_path__ + "static/media/clue-4.3840cd4e.svg";